export default {
  state: () => ({
    isMini: false,
    isLoad: true
  }),
  mutations: {
    SET_LOAD (state, data) {
      state.isLoad = data
    }
  },
  actions: {

  },
  getters: {

  }
}
